import { LoadingButton } from "@mui/lab";
import { Alert, Box, Grid, TextField, useMediaQuery } from "@mui/material";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createMachineThunk,
  getMachineThunk,
  updateMachineThunk,
} from "store/reducers/vending";
import * as yup from "yup";

const validation = yup.object({
  name: yup.string("Enter a name").required("Name required"),
  desc: yup.string("Give a description"),
});

const CreateMachineForm = ({
  handleNext,
  machine = null,
  fullGrid = false,
}) => {
  const vendingState = useSelector((state) => state.vending);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      name: machine ? machine?.name ?? "" : "",
      desc: machine ? machine?.desc ?? "" : "",
    },
    validationSchema: validation,
    onSubmit: (data) => {
      if (machine) {
        dispatch(updateMachineThunk({ id: machine.id, data: data }));
      } else {
        dispatch(createMachineThunk(data));
      }
    },
  });

  const isFullWidth = useMediaQuery((theme) => theme.breakpoints.down("md"));

  useEffect(() => {
    console.log(vendingState.createMachineErrorMessage);
    if (vendingState.createMachineErrorMessage) {
      Object.keys(vendingState.createMachineErrorMessage).forEach((key) => {
        console.log(key, vendingState.createMachineErrorMessage[key][0]);
        formik.setFieldError(
          key,
          vendingState.createMachineErrorMessage[key][0]
        );
      });
    }
  }, [vendingState.createMachineErrorMessage]);

  useEffect(() => {
    console.log(vendingState.updateMachineErrorMessage);
    if (vendingState.updateMachineErrorMessage) {
      Object.keys(vendingState.updateMachineErrorMessage).forEach((key) => {
        console.log(key, vendingState.updateMachineErrorMessage[key][0]);
        formik.setFieldError(
          key,
          vendingState.updateMachineErrorMessage[key][0]
        );
      });
    }
  }, [vendingState.updateMachineErrorMessage]);

  return (
    <Box sx={{ mb: 2 }}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container columnSpacing={2} rowSpacing={0}>
          <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
            <Box display="flex" flexDirection="column">
              <TextField
                label="Name"
                variant="outlined"
                name="name"
                fullWidth
                sx={{ mt: 3 }}
                value={formik.values.name}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.name)}
                helperText={formik.errors.name}
                autoComplete="new-password"
                required
              />
              <TextField
                label="Description"
                variant="outlined"
                name="desc"
                autoComplete="new-password"
                fullWidth
                multiline
                maxRows={4}
                sx={{ mt: 3 }}
                value={formik.values.desc}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.desc)}
                helperText={formik.errors.desc}
              />
            </Box>
            {(vendingState.createMachineError ||
              vendingState.createMachineError) && (
              <Alert sx={{ mt: 3 }} severity="error">
                Error occurred
              </Alert>
            )}
            {(vendingState.createMachineSuccess ||
              vendingState.updateMachineSuccess) && (
              <Alert sx={{ mt: 3 }} severity="success">
                Success
              </Alert>
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row-reverse",
              }}
            >
              <LoadingButton
                loading={
                  vendingState.createMachineLoading ||
                  vendingState.updateMachineLoading
                }
                variant="contained"
                fullWidth={isFullWidth}
                sx={{ mt: 3 }}
                type="submit"
              >
                {machine ? "Update" : "Continue"}
              </LoadingButton>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default CreateMachineForm;
